<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <PageHeader :title="title" :items="items"/>
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label for="upazila_id">Upazila <span class="c-required">*</span></label>
                                <select v-model="search_data.upazila_id" v-validate="'required'" class="form-control form-control-sm" name="upazila_id" id="upazila_id">
                                    <option selected :value="''">Select a Upazila</option>
                                    <option v-for="(upazila, index) in upazilas" :key="index" :value="upazila.id">{{upazila.id}} : {{ upazila.upazila_desc }}</option>
                                </select>
                                <div class="invalid-feedback">Please select upazila</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4 mt-2">
                              <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                              <b-button @click.prevent="addTreeRateModal()" class="btn btn-success btn-sm float-right" style="margin-top: 28px;">Add Tree Rate</b-button>
                            </div>
                        </div>
                    </form>
                </b-card>

                <b-card>
<!--                    <b-button @click.prevent="addTreeRateModal()" class="btn btn-success btn-sm pull-right mb-2">Add Tree Rate</b-button>-->
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-condensed  table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Upazila</th>
                                <th>Tree Name</th>
                                <th>DC rate(large)</th>
                                <th>DC rate(small)</th>
                                <th>DC rate(saplings)</th>
                                <th>PVAC rate(large)</th>
                                <th>PVAC rate(saplings)</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(tree_rate, index) in tree_rates" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ tree_rate.upazila.upazila_desc }}</td>
                                <td><span v-if="tree_rate.tree_name != null">{{ tree_rate.tree_name.tree_name_desc }}</span></td>
                                <td>{{ tree_rate.dc_rate_large }}</td>
                                <td>{{ tree_rate.dc_rate_small }}</td>
                                <td>{{ tree_rate.dc_rate_saplings }}</td>
                                <td>{{ tree_rate.pvac_rate_large }}</td>
                                <td>{{ tree_rate.pvac_rate_saplings }}</td>
                                <td>
                                    <a
                                       @click.prevent="updateTreeRateModal(tree_rate)" class="action-icon"
                                       href="javascript:void(0);" title="Update Tree Rate">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 class="text-center text-secondary" v-if="tree_rates.length == 0">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <add-tree-rate-modal
                :tree_rate_data="tree_rate_data"
                :upazilas="upazilas"
                :tree_names="tree_names"
                :btn_edit="btn_edit"
                @search="search">
        </add-tree-rate-modal>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import addTreeRateModal from "../modals/addTreeRateModal";

    export default {
        page: {
            title: "List Tree Rate",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, addTreeRateModal},
        data() {
            return {
                title: "Search Tree Rate",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Tree Rate",
                        active: true
                    }
                ],
                tree_rates: [],
                tree_rate_data: {},
                search_data: {
                    upazila_id: '',
                },
                upazilas: [],
                tree_names: [],
                btn_edit: false,
                flag: false
            };
        },

        mounted() {
            this.getCodes();
        },
        methods: {
          getCodes() {
                http.get("api/rate/tree/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.upazilas = data.upazilas;
                        this.tree_names = data.tree_names;
                    }
                });
            },
            addTreeRateModal() {
                this.btn_edit = false;
                this.tree_rate_data = {};
                this.$root.$emit("bv::show::modal", "add-tree-rate-modal");
            },
            updateTreeRateModal(tree_rate) {
                this.btn_edit = true;
                http.get("api/rate/trees/" + tree_rate.id + "/edit")
                    .then(resource => {
                        this.tree_rate_data = resource.data.tree_rate
                    })
                    .catch(error => console.log(error))
                this.$root.$emit("bv::show::modal", "add-tree-rate-modal");
            },
            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http.post("api/rate/tree/search", this.search_data).then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.tree_rates = response.data.tree_rates;
                            }
                        });
                    }
                });
            },

        },
    };
</script>
<style>
  .table-condensed>thead>tr>th,
  .table-condensed>tbody>tr>th,
  .table-condensed>tfoot>tr>th,
  .table-condensed>thead>tr>td,
  .table-condensed>tbody>tr>td,
  .table-condensed>tfoot>tr>td{
    padding: 5px;
  }
</style>
